import { useState, useEffect, useContext } from 'react';
import classes from './CompanyInfoTab.module.scss';
import i18n from '../../../../../utils/i18n';
import Selector from '../../../../components/Selector';
import SelectorDropdown from '../../../../components/SelectorDropdown';
import { Divider, Checkbox, FormControlLabel } from '@mui/material';
import TextfieldIcon from '../../../../components/TextfieldIcon';
import NameIcon from '../../../../../images/size-option-large-office.svg';
import HashtagIcon from '../../../images/general-icon-hashtag.svg';
import ProfileIcon from '../../../../../images/size-option-individual.svg';
import WebIcon from '../../../images/contact-icon-web.svg';
import CityIcon from '../../../images/companyinfo-icon-city.svg';
import ZIPCodeIcon from '../../../images/general-icon-hashtag.svg';
import AddressIcon from '../../../images/companyinfo-icon-address.svg';
import LanguageCheckOn from '../../../../../images/LanguageIcons/language-check-on.svg';
import LanguageCheckOff from '../../../../../images/LanguageIcons/language-check-off.svg';
import CustomButton from '../../../../components/CustomButton';
import IconTickWhite from '../../../../../images/icon-tick-white.svg';
import IconTrash from '../../../../../images/icon-trash.svg';
import IconPlusGrey from '../../../../../images/icon-plus-grey.svg';
import { cities } from '../../../../../company/searchFlow/data/cities';

import InputContext from '../../../../../context/inputContext';
import { useSelector, useDispatch } from 'react-redux';
import ACTIONS from '../../../../../redux/action';

const CompanyInfoTab = () => {
	const dispatch = useDispatch();

	const providerData = useSelector((state) => state);

	const { isChanged, setIsChanged } = useContext(InputContext);
	const [selectedCompany, setSelectedCompany] = useState(0);
	const [showSecondary, setShowSecondary] = useState(false);
	const [isSameAsCompany, setIsSameAsCompany] = useState(false);

	const infoChecker = {
		companyName: providerData.provider_info.companyname,
		taxnumber: providerData.provider_info.taxnumber,
		registrationno: providerData.provider_info.registrationno,
		authorizedperson: providerData.provider_info.authorizedperson,
		zip: providerData.provider_info.zip,
		city: providerData.provider_info.city,
		address: providerData.provider_info.address,
	};

	const [searchValue, setSearchValue] = useState('');
	const onSearch = (searchTerm) => {
		setSearchValue(searchTerm);
	};
	const [searchValue2, setSearchValue2] = useState('');
	const onSearch2 = (searchTerm) => {
		setSearchValue2(searchTerm);
	};
	const [searchValue3, setSearchValue3] = useState('');
	const onSearch3 = (searchTerm) => {
		setSearchValue3(searchTerm);
	};
	const [searchValue4, setSearchValue4] = useState('');
	const onSearch4 = (searchTerm) => {
		setSearchValue4(searchTerm);
	};

	const valueCheck = (data) => {
		if (typeof data === 'object' && data !== null) {
			const values = Object.values(data);

			return values.every(
				(value) =>
					value !== undefined && value !== null && value !== '' && value !== 0
			);
		}
		return false;
	};

	useEffect(() => {
		if (
			providerData.provider_onboarding.companyinfo_flow.iscompleted === false
		) {
			if (valueCheck(infoChecker) === true) {
				dispatch(
					ACTIONS.updateNestedObject({
						id: 'iscompleted',
						data: true,
						stateObject: 'provider_onboarding',
						stateObjectID: `companyinfo_flow`,
					})
				);
			}
		} else if (
			providerData.provider_onboarding.companyinfo_flow.iscompleted === true
		) {
			if (valueCheck(infoChecker) === false) {
				dispatch(
					ACTIONS.updateNestedObject({
						id: 'iscompleted',
						data: false,
						stateObject: 'provider_onboarding',
						stateObjectID: `companyinfo_flow`,
					})
				);
			}
		}
	}, [providerData.provider_info]);

	useEffect(() => {
		providerData.provider_contact.contactcity.length > 0 &&
			setIsSameAsCompany(true);
	}, [providerData]);

	const handleCheckboxChange = (event) => {
		setIsSameAsCompany(event.target.checked);
	};

	const handleChange = (event, storeObj) => {
		dispatch(
			ACTIONS.addProviderInfo({
				id: event.target.id,
				data: event.target.value,
				stateObject: storeObj,
			})
		);
	};

	const resetSecondary = () => {
		Object.keys(providerData.provider_info).forEach((e) => {
			if (e.includes('secondary')) {
				dispatch(
					ACTIONS.addProviderInfo({
						id: e,
						data: '',
						stateObject: 'provider_info',
					})
				);
			}
		});
		Object.keys(providerData.provider_contact).forEach((e) => {
			if (e.includes('secondary')) {
				dispatch(
					ACTIONS.addProviderInfo({
						id: e,
						data: '',
						stateObject: 'provider_contact',
					})
				);
			}
		});
	};

	useEffect(() => {
		if (providerData.provider_info.secondarycompanyname) {
			setShowSecondary(true);
		}
	}, [providerData.provider_info.secondarycompanyname]);

	return (
		<>
			<div className={classes.paragraph}>
				<Selector
					labelTop={i18n.t('provider.companyname')}
					labelBottom={providerData.provider_info.companyname}
					selected={selectedCompany === 0}
					borderRadius='8px'
					borderSides={{ top: true, right: true, bottom: true, left: true }}
					onToggle={(e) => setSelectedCompany(0)}
				/>
				{!showSecondary && (
					<div className={classes.secondSelector}>
						<CustomButton
							buttonName={i18n.t('provider.addnewcompany')}
							iconSrc={IconPlusGrey}
							buttonColor='#fafcfe'
							hoverColor='#fafcfe'
							titleColor='#4b5080'
							titleHoverColor='#4b5080'
							width='100%'
							height='84px'
							padding='12px'
							borderColor='#e3e5e9'
							borderWidth='1px'
							onClick={() => setShowSecondary(true)}
						/>
					</div>
				)}

				{showSecondary && (
					<div className={classes.secondSelector}>
						<Selector
							labelTop={i18n.t('provider.companyname')}
							labelBottom={providerData.provider_info.secondarycompanyname}
							selected={selectedCompany === 1}
							borderRadius='8px'
							onToggle={(e) => setSelectedCompany(1)}
						/>
					</div>
				)}
			</div>
			{selectedCompany === 0 ? (
				<>
					<div className={classes.paragraph}>
						<div className={classes.leftColumn}>
							<div className={classes.profileTitle}>
								{i18n.t('provider.companyinfo')}
							</div>
						</div>
						<div className={classes.rightColumn}>
							<div className={classes.basicInfosGroup}>
								<div className={classes.paragraphTop}>
									{/* <SelectorDropdown
								label={i18n.t('provider.companytype')}
								options={[
									i18n.t('companyforms.kftacronym'),
									i18n.t('companyforms.btacronym'),
									i18n.t('companyforms.evacronym'),
								]}
								placeholder='-'
								isRequired={true}
								showAsterix={true}
								onSelect={handleSelect}
							/> */}
								</div>
								<TextfieldIcon
									id='companyname'
									label={i18n.t('general.companyname')}
									iconSrc={NameIcon}
									placeholder='-'
									value={providerData.provider_info.companyname}
									isRequired={true}
									showAsterix={true}
									onChange={(e) => {
										handleChange(e, 'provider_info');
										setIsChanged(true);
									}}
								/>
								<TextfieldIcon
									id='taxnumber'
									value={providerData.provider_info.taxnumber}
									label={i18n.t('general.taxnumber')}
									iconSrc={HashtagIcon}
									placeholder='-'
									isRequired={true}
									showAsterix={true}
									onChange={(e) => {
										handleChange(e, 'provider_info');
										setIsChanged(true);
									}}
								/>
								<TextfieldIcon
									value={providerData.provider_info.registrationno}
									id='registrationno'
									label={i18n.t('general.registrationnumber')}
									iconSrc={HashtagIcon}
									placeholder='-'
									isRequired={true}
									showAsterix={true}
									onChange={(e) => {
										handleChange(e, 'provider_info');
										setIsChanged(true);
									}}
								/>
								<TextfieldIcon
									value={providerData.provider_info.authorizedperson}
									id='authorizedperson'
									label={i18n.t('general.authorizedname')}
									iconSrc={ProfileIcon}
									placeholder='-'
									isRequired={true}
									showAsterix={true}
									onChange={(e) => {
										handleChange(e, 'provider_info');
										setIsChanged(true);
									}}
								/>
							</div>
						</div>
					</div>

					<Divider />

					<div className={classes.paragraph}>
						<div className={classes.leftColumn}>
							<div className={classes.profileTitle}>
								{i18n.t('general.registeredoffice')}
							</div>
						</div>

						<div className={classes.rightColumn}>
							<TextfieldIcon
								value={providerData.provider_info.city}
								id='city'
								label={i18n.t('general.city')}
								iconSrc={CityIcon}
								placeholder='-'
								isRequired={true}
								showAsterix={true}
								onChange={(e) => {
									setSearchValue(e.target.value);
									setIsChanged(true);
								}}
							/>
							{searchValue &&
								providerData.provider_info.city !== searchValue && (
									<div className={classes.cityList}>
										{cities
											.filter((item) =>
												item.city
													.toLowerCase()
													.includes(searchValue.toLowerCase())
											)
											.map(
												(item, idx) =>
													searchValue !== item.city && (
														<div
															style={{ padding: '2px' }}
															key={idx + item.zip}
															onClick={() => {
																onSearch(item.city);
																dispatch(
																	ACTIONS.addCompanyInfo({
																		id: 'zip',
																		data: item.zip,
																		stateObject: 'provider_info',
																	})
																);
																dispatch(
																	ACTIONS.addCompanyInfo({
																		id: 'city',
																		data: item.city,
																		stateObject: 'provider_info',
																	})
																);
															}}>
															{item.city}
														</div>
													)
											)}
									</div>
								)}
							<TextfieldIcon
								value={providerData.provider_info.address}
								id='address'
								label={i18n.t('general.address')}
								iconSrc={AddressIcon}
								placeholder='-'
								isRequired={true}
								showAsterix={true}
								onChange={(e) => {
									handleChange(e, 'provider_info');
									setIsChanged(true);
								}}
							/>
						</div>
					</div>
					<div style={{ marginLeft: '2rem' }}>
						<FormControlLabel
							control={
								<Checkbox
									checked={isSameAsCompany}
									onChange={(e) => {
										handleCheckboxChange(e);
										setIsChanged(true);
									}}
									color='primary'
									icon={
										<img
											src={LanguageCheckOff}
											alt={i18n.t('general.uncheckedIcon')}
											style={{
												width: '16px',
												height: '16px',
												cursor: 'pointer',
											}}
										/>
									}
									checkedIcon={
										<img
											src={LanguageCheckOn}
											alt={i18n.t('general.checkedIcon')}
											style={{
												width: '16px',
												height: '16px',
												cursor: 'pointer',
											}}
										/>
									}
								/>
							}
							label={
								<span
									style={{
										fontFamily: 'Satoshi, sans-serif',
										fontSize: '14px',
										fontWeight: '500',
									}}>
									Adresa secundara
								</span>
							}
						/>
					</div>
					{isSameAsCompany && (
						<>
							<Divider />

							<div className={classes.paragraph}>
								<div className={classes.leftColumn}>
									<div className={classes.profileTitle}>
										{i18n.t('general.billingaddress')}
									</div>
								</div>

								<div className={classes.rightColumn}>
									{/* <TextfieldIcon
								label={i18n.t('general.companyname')}
								iconSrc={NameIcon}
								placeholder='-'
								isRequired={true}
								value={nameBilling}
								showAsterix={true}
								onChange={(e) => setNameBilling(e.target.value)}
							/>
							<TextfieldIcon
								label={i18n.t('general.taxnumber')}
								iconSrc={HashtagIcon}
								placeholder='-'
								isRequired={true}
								value={taxNumberBilling}
								showAsterix={true}
								onChange={(e) => setTaxNumberBilling(e.target.value)}
							/>
							<TextfieldIcon
								label={i18n.t('general.country')}
								iconSrc={WebIcon}
								placeholder='-'
								isRequired={true}
								value={countryBilling}
								showAsterix={true}
								onChange={(e) => setCountryBilling(e.target.value)}
							/> */}
									<TextfieldIcon
										value={providerData.provider_contact.contactcity}
										id='contactcity'
										onChange={(e) => {
											setSearchValue2(e.target.value);
											setIsChanged(true);
										}}
										label={i18n.t('general.city')}
										iconSrc={CityIcon}
										placeholder='-'
										isRequired={true}
										showAsterix={true}
									/>
									{searchValue2 &&
										providerData.provider_info.city !== searchValue2 && (
											<div className={classes.cityList}>
												{cities
													.filter((item) =>
														item.city
															.toLowerCase()
															.includes(searchValue2.toLowerCase())
													)
													.map(
														(item, idx) =>
															searchValue2 !== item.city && (
																<div
																	style={{ padding: '2px' }}
																	key={idx + item.zip}
																	onClick={() => {
																		onSearch2(item.city);
																		dispatch(
																			ACTIONS.addCompanyInfo({
																				id: 'contactzip',
																				data: item.zip,
																				stateObject: 'provider_contact',
																			})
																		);
																		dispatch(
																			ACTIONS.addCompanyInfo({
																				id: 'contactcity',
																				data: item.city,
																				stateObject: 'provider_contact',
																			})
																		);
																	}}>
																	{item.city}
																</div>
															)
													)}
											</div>
										)}

									<TextfieldIcon
										value={providerData.provider_contact.contactaddress}
										id='contactaddress'
										onChange={(e) => {
											handleChange(e, 'provider_contact');
											setIsChanged(true);
										}}
										label={i18n.t('general.address')}
										iconSrc={AddressIcon}
										placeholder='-'
										isRequired={true}
										showAsterix={true}
									/>
								</div>
							</div>
						</>
					)}

					{/* <div className={classes.buttonsContainer}>
        <CustomButton
          buttonName={i18n.t('provider.deletecompany')}
          iconSrc={IconTrash}
          buttonColor='#fafcfe'
          hoverColor='#fafcfe'
          titleColor='#4b5080'
          titleHoverColor='#4b5080'
          width='16%'
          height='44px'
          padding='12px'
          borderColor='#e3e5e9'
          borderWidth='1px'
        />
        
      </div> */}
				</>
			) : (
				<>
					<div className={classes.paragraph}>
						<div className={classes.leftColumn}>
							<div className={classes.profileTitle}>
								{i18n.t('provider.companyinfo')}
							</div>
						</div>
						<div className={classes.rightColumn}>
							<div className={classes.basicInfosGroup}>
								<div className={classes.paragraphTop}>
									{/* <SelectorDropdown
						label={i18n.t('provider.companytype')}
						options={[
							i18n.t('companyforms.kftacronym'),
							i18n.t('companyforms.btacronym'),
							i18n.t('companyforms.evacronym'),
						]}
						placeholder='-'
						isRequired={true}
						showAsterix={true}
						onSelect={handleSelect}
					/> */}
								</div>
								<TextfieldIcon
									id='secondarycompanyname'
									label={i18n.t('general.companyname')}
									iconSrc={NameIcon}
									placeholder='-'
									value={providerData.provider_info.secondarycompanyname}
									isRequired={true}
									showAsterix={true}
									onChange={(e) => {
										handleChange(e, 'provider_info');
										setIsChanged(true);
									}}
								/>
								<TextfieldIcon
									id='secondarytaxnumber'
									value={providerData.provider_info.secondarytaxnumber}
									label={i18n.t('general.taxnumber')}
									iconSrc={HashtagIcon}
									placeholder='-'
									isRequired={true}
									showAsterix={true}
									onChange={(e) => {
										handleChange(e, 'provider_info');
										setIsChanged(true);
									}}
								/>
								<TextfieldIcon
									value={providerData.provider_info.secondaryregistrationno}
									id='secondaryregistrationno'
									label={i18n.t('general.registrationnumber')}
									iconSrc={HashtagIcon}
									placeholder='-'
									isRequired={true}
									showAsterix={true}
									onChange={(e) => {
										handleChange(e, 'provider_info');
										setIsChanged(true);
									}}
								/>
								<TextfieldIcon
									value={providerData.provider_info.secondaryauthorizedperson}
									id='secondaryauthorizedperson'
									label={i18n.t('general.authorizedname')}
									iconSrc={ProfileIcon}
									placeholder='-'
									isRequired={true}
									showAsterix={true}
									onChange={(e) => {
										handleChange(e, 'provider_info');
										setIsChanged(true);
									}}
								/>
							</div>
						</div>
					</div>

					<Divider />

					<div className={classes.paragraph}>
						<div className={classes.leftColumn}>
							<div className={classes.profileTitle}>
								{i18n.t('general.registeredoffice')}
							</div>
						</div>

						<div className={classes.rightColumn}>
							<div className={classes.paragraphTop}>
								{/* <TextfieldIcon
					label={i18n.t('general.country')}
					iconSrc={WebIcon}
					placeholder='-'
					isRequired={true}
					showAsterix={true}
					onChange={(e) => setCountry(e.target.value)}
				/> */}
							</div>

							<TextfieldIcon
								value={providerData.provider_info.secondarycity}
								id='secondarycity'
								label={i18n.t('general.city')}
								iconSrc={CityIcon}
								placeholder='-'
								isRequired={true}
								showAsterix={true}
								onChange={(e) => {
									setSearchValue3(e.target.value);
									setIsChanged(true);
								}}
							/>
							{searchValue3 &&
								providerData.provider_info.secondarycity !== searchValue3 && (
									<div className={classes.cityList}>
										{cities
											.filter((item) =>
												item.city
													.toLowerCase()
													.includes(searchValue3.toLowerCase())
											)
											.map(
												(item, idx) =>
													searchValue3 !== item.city && (
														<div
															style={{ padding: '2px' }}
															key={idx + item.zip}
															onClick={() => {
																onSearch3(item.city);
																dispatch(
																	ACTIONS.addCompanyInfo({
																		id: 'secondaryzip',
																		data: item.zip,
																		stateObject: 'provider_info',
																	})
																);
																dispatch(
																	ACTIONS.addCompanyInfo({
																		id: 'secondarycity',
																		data: item.city,
																		stateObject: 'provider_info',
																	})
																);
															}}>
															{item.city}
														</div>
													)
											)}
									</div>
								)}
							<TextfieldIcon
								value={providerData.provider_info.secondaryaddress}
								id='secondaryaddress'
								label={i18n.t('general.address')}
								iconSrc={AddressIcon}
								placeholder='-'
								isRequired={true}
								showAsterix={true}
								onChange={(e) => {
									handleChange(e, 'provider_info');
									setIsChanged(true);
								}}
							/>
						</div>
					</div>
					<div style={{ margin: '24px' }}>
						{window.innerWidth < 480 ? (
							<CustomButton
								buttonName={i18n.t('provider.deletecompanyaam')}
								iconSrc={IconTrash}
								buttonColor='#fafcfe'
								hoverColor='#fafcfe'
								titleColor='#4b5080'
								titleHoverColor='#4b5080'
								padding='12px'
								borderColor='#e3e5e9'
								borderWidth='1px'
								width='100%'
								onClick={() => {
									if (window.confirm(i18n.t('provider.confirmdelete'))) {
										setShowSecondary(false);
										setSelectedCompany(0);
										resetSecondary();
									}
								}}
							/>
						) : (
							<CustomButton
								buttonName={i18n.t('provider.deletecompanyaam')}
								iconSrc={IconTrash}
								buttonColor='#fafcfe'
								hoverColor='#fafcfe'
								titleColor='#4b5080'
								titleHoverColor='#4b5080'
								padding='12px'
								borderColor='#e3e5e9'
								borderWidth='1px'
								onClick={() => {
									if (window.confirm(i18n.t('provider.confirmdelete'))) {
										setShowSecondary(false);
										setSelectedCompany(0);
										resetSecondary();
									}
								}}
							/>
						)}
					</div>
					<div style={{ marginLeft: '2rem' }}>
						<FormControlLabel
							control={
								<Checkbox
									checked={isSameAsCompany}
									onChange={handleCheckboxChange}
									color='primary'
									icon={
										<img
											src={LanguageCheckOff}
											alt={i18n.t('general.uncheckedIcon')}
											style={{
												width: '16px',
												height: '16px',
												cursor: 'pointer',
											}}
										/>
									}
									checkedIcon={
										<img
											src={LanguageCheckOn}
											alt={i18n.t('general.checkedIcon')}
											style={{
												width: '16px',
												height: '16px',
												cursor: 'pointer',
											}}
										/>
									}
								/>
							}
							label={
								<span
									style={{
										fontFamily: 'Satoshi, sans-serif',
										fontSize: '14px',
										fontWeight: '500',
									}}>
									Adresa secundara
								</span>
							}
						/>
					</div>
					{isSameAsCompany && (
						<>
							<Divider />

							<div className={classes.paragraph}>
								<div className={classes.leftColumn}>
									<div className={classes.profileTitle}>
										{i18n.t('general.billingaddress')}
									</div>
								</div>

								<div className={classes.rightColumn}>
									<TextfieldIcon
										value={providerData.provider_contact.secondarycontactcity}
										id='secondarycontactcity'
										onChange={(e) => setSearchValue4(e.target.value)}
										label={i18n.t('general.city')}
										iconSrc={CityIcon}
										placeholder='-'
										isRequired={true}
										showAsterix={true}
									/>
									{searchValue4 &&
										providerData.provider_contact.secondarycontactcity !==
											searchValue4 && (
											<div className={classes.cityList}>
												{cities
													.filter((item) =>
														item.city
															.toLowerCase()
															.includes(searchValue4.toLowerCase())
													)
													.map(
														(item, idx) =>
															searchValue4 !== item.city && (
																<div
																	style={{ padding: '2px' }}
																	key={idx + item.zip}
																	onClick={() => {
																		onSearch4(item.city);
																		dispatch(
																			ACTIONS.addCompanyInfo({
																				id: 'secondarycontactzip',
																				data: item.zip,
																				stateObject: 'provider_contact',
																			})
																		);
																		dispatch(
																			ACTIONS.addCompanyInfo({
																				id: 'secondarycontactcity',
																				data: item.city,
																				stateObject: 'provider_contact',
																			})
																		);
																	}}>
																	{item.city}
																</div>
															)
													)}
											</div>
										)}
									<TextfieldIcon
										value={
											providerData.provider_contact.secondarycontactaddress
										}
										id='secondarycontactaddress'
										onChange={(e) => {
											handleChange(e, 'provider_contact');
											setIsChanged(true);
										}}
										label={i18n.t('general.address')}
										iconSrc={AddressIcon}
										placeholder='-'
										isRequired={true}
										showAsterix={true}
									/>
								</div>
							</div>
						</>
					)}

					{/* <div className={classes.buttonsContainer}>

<CustomButton
  buttonName={i18n.t('general.save')}
  iconSrc={IconTickWhite}
  buttonColor='#1c32f3'
  hoverColor='#0036cc'
  titleColor='#ffffff'
  titleHoverColor='#e0e0e0'
  width='94px'
  height='44px'
  padding='12px'
// borderColor='#e3e5e9'
// borderWidth='1px'
/>
</div> */}

					{/* <CustomButton
		buttonName={i18n.t('provider.addnewcompany')}
		iconSrc={IconPlusGrey}
		buttonColor='#fafcfe'
		hoverColor='#fafcfe'
		titleColor='#4b5080'
		titleHoverColor='#4b5080'
		width='16%'
		height='44px'
		padding='12px'
		borderColor='#e3e5e9'
		borderWidth='1px'
	/> */}
				</>
			)}
		</>
	);
};

export default CompanyInfoTab;
